import auth from './auth';
import application_info from './application_info';
import referee_info from './referee_info';
import document from './document';
import important_note from './important_note';
import personal_particular from './personal_particular';
import education_background from './education_background';
import review_submission from './review_submission';
import application_status from './application_status';
import event from './event';

const API = {
	auth,
	application_info,
	referee_info,
	document,
	important_note,
	personal_particular,
	education_background,
	review_submission,
	application_status,
	event
};

export default API;